//@flow
import React from 'react';
import SwitchableSection from '../../../../../elements/SwitchableSection';
import {useMinimalProducts} from '../../../../products/utils/hooks';
import {Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import {getImageUrl} from '../../../../../utils/image_provider';
import {useStoreCurrency} from '../../../../currency/utils';
import {commaFormat} from '../../../../../utils/number';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
  title: {
    fontWeight: 600,
    fontSize: '1rem',
    color: colors.grey800,
  },
  productList: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    overflow: 'auto',
    width: '100%',
    padding: '.25rem',
  },
  productCard: {
    width: '100%',
    maxWidth: '160px',
    minWidth: '140px',
    padding: '1rem',
    aspectRatio: '2/1',
    background: 'white',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
    borderRadius: '.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
  image: {
    width: '100%',
    aspectRatio: '1',
    borderRadius: '.5rem',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  productName: {
    width: '100%',
    height: '2.5rem',
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitLineClamp: 2,
    boxOrient: 'vertical',
  },
  productPrice: {
    width: '100%',
    height: '1rem',
    borderRadius: '.5rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
}));

const productParams = {size: 5};

type Props = {
  sectionEnabled?: boolean,
};

export default function RecentProducts(props: Props) {
  const {sectionEnabled} = props;
  const currency = useStoreCurrency();

  const classes = useStyles();

  const {products, loading} = useMinimalProducts(productParams);

  const loadingProducts = loading;

  return (
    <SwitchableSection
      id={HOME_PAGE_SECTION_NAMES.RECENT_PRODUCTS}
      title="Sección novedades"
      subtitle="Activa esta opción para mostrar los últimos productos cargados o editados en la plataforma."
      classes={{
        root: !sectionEnabled ? classes.disabledRoot : '',
      }}
      loading={!!loadingProducts}
    >
      <div className={classes.root}>
        <Typography className={classes.title}>Novedades</Typography>

        <div className={classes.productList}>
          {products.map(product => (
            <div key={product.id} className={classes.productCard}>
              <picture className={classes.image}>
                <img
                  src={getImageUrl(product.mainImageId)}
                  alt={product.name}
                />
              </picture>

              <span className={classes.productName}>{product.name}</span>

              <span className={classes.productPrice}>
                {commaFormat(product.price, currency?.symbol)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </SwitchableSection>
  );
}
